<template>
	<div>
		<el-divider content-position="left" border-style="dotted">Filter</el-divider>
		<el-form :model="rekapFilter" label-width="auto" label-position="top" :disabled="downloading">
			<el-row :gutter="10" align="middle">
				<el-col :xs="24" :sm="8" :md="6" :xl="4">
					<el-form-item label="Jenis Pengguna" prop="type">
						<el-select v-model="rekapFilter.type" placeholder="Pilih jenis pengguna" clearable>
							<el-option v-for="t in listUserType" :key="t.value" :label="t.label" :value="t.value" />
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="16" :md="12" :xl="10">
					<el-form-item label="Tanggal" prop="tanggal">
						<el-date-picker
							v-model="rekapFilter.tanggal"
							type="daterange"
							range-separator="s/d"
							format="DD MMMM YYYY"
							value-format="YYYY-MM-DD"
							start-placeholder="Tanggal Awal"
							end-placeholder="Tanggal Akhir" />
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="6" :md="6" :xl="4" v-if="rekapFilter.type === 'siswa'">
					<el-form-item label="Semester" prop="semester_id">
						<el-select v-model="rekapFilter.semester_id" filterable :placeholder="`${semesterAktif.nama || 'Semester Aktif'}`">
							<el-option v-for="s in listSemester" :key="s.semester_id" :label="s.nama" :value="s.semester_id" />
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="6" :md="6" :xl="4" v-if="rekapFilter.type === 'siswa'">
					<el-form-item label="Rombel" prop="rombel_id">
						<el-select v-model="rekapFilter.rombel_id" filterable placeholder="Pilih Rombel" clearable>
							<el-option v-for="r in listRombel" :key="r.rombel_id" :label="r.nama" :value="r.rombel_id" />
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<div v-if="isPetugasPresensi" class="row row-cols-auto g-2 justify-content-end mt-3">
				<el-button
					@click="generateRekapPresensi"
					plain
					round
					type="info"
					icon="EditPen"
					:loading="downloading"
					:disabled="rekapFilter.type === null || rekapFilter.tanggal === null">
					Buat Rekapitulasi Presensi
				</el-button>
				<el-button @click="downloadRekapPresensi" round type="success" icon="Download" :loading="downloading" :disabled="rekapFilter.type === null">
					Unduh Rekapitulasi Presensi
				</el-button>
			</div>
		</el-form>
		<el-divider border-style="dotted" />

		<transition name="fade" mode="out-in">
			<div v-if="rekapFilter.type">
				<el-row :gutter="10" align="middle" justify="end" class="mb-3">
					<el-col :xs="24" :sm="12" :md="10" :xl="7">
						<el-input v-model="rekapFilter.search_key" placeholder="Cari . . ." prefix-icon="Search" clearable />
					</el-col>
				</el-row>
				<el-table :data="rekapPresensi" row-key="user_presensi_id" table-layout="auto" stripe v-loading="loading">
					<template #empty>
						<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
					</template>
					<el-table-column fixed type="index" label="No." :index="indexMethod" align="center" />
					<el-table-column fixed label="Nama" prop="nama" header-align="center" />
					<el-table-column fixed label="Lihat Detail" align="center">
						<template #default="{ row }">
							<el-tooltip content="Lihat detail rekap" placement="right">
								<el-button type="info" plain round icon="InfoFilled" @click="showDetail(row)" size="small" />
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column label="ID Presensi" prop="user_presensi_id" align="center">
						<template #default="{ row }">
							<transition name="fade" mode="out-in">
								<span :key="row.user_presensi_id">{{ row.user_presensi_id }}</span>
							</transition>
						</template>
					</el-table-column>
					<el-table-column label="NIS" prop="nis" align="center" v-if="rekapFilter.type === 'siswa'" />
					<el-table-column label="Rombel" prop="nama_rombel" align="center" v-if="rekapFilter.type === 'siswa'" />
					<el-table-column label="Status" prop="singkatan_status" align="center" v-if="rekapFilter.type === 'siswa'" />
					<el-table-column label="Terjadwal" prop="terjadwal" align="center">
						<template #default="{ row }">
							{{ row.terjadwal ? row.terjadwal + " hari" : "-" }}
						</template>
					</el-table-column>
					<el-table-column label="Masuk" align="center">
						<el-table-column label="Tepat" prop="tepat_masuk" align="center" :formatter="formatterKali" />
						<el-table-column label="Terlambat" prop="terlambat_masuk" align="center" :formatter="formatterKali" />
						<el-table-column label="Tidak Presensi" prop="tidak_presensi_masuk" align="center" :formatter="formatterKali" />
						<el-table-column label="Sakit" prop="sakit_masuk" align="center" :formatter="formatterKali" />
						<el-table-column label="Izin Dinas" prop="izin_dinas_masuk" align="center" :formatter="formatterKali" />
						<el-table-column label="Izin Pribadi" prop="izin_pribadi_masuk" align="center" :formatter="formatterKali" />
					</el-table-column>
					<el-table-column label="Pulang" align="center">
						<el-table-column label="Tepat" prop="tepat_pulang" align="center" :formatter="formatterKali" />
						<el-table-column label="Lebih Cepat" prop="pulang_cepat" align="center" :formatter="formatterKali" />
						<el-table-column label="Tidak Presensi" prop="tidak_presensi_pulang" align="center" :formatter="formatterKali" />
						<el-table-column label="Sakit" prop="sakit_pulang" align="center" :formatter="formatterKali" />
						<el-table-column label="Izin Dinas" prop="izin_dinas_pulang" align="center" :formatter="formatterKali" />
						<el-table-column label="Izin Pribadi" prop="izin_pribadi_pulang" align="center" :formatter="formatterKali" />
					</el-table-column>
					<el-table-column label="Tidak Masuk" align="center">
						<el-table-column label="Sakit" prop="sakit" align="center" :formatter="formatterKali" />
						<el-table-column label="Izin Dinas" prop="izin_dinas" align="center" :formatter="formatterKali" />
						<el-table-column label="Izin Pribadi" prop="izin_pribadi" align="center" :formatter="formatterKali" />
						<el-table-column label="Cuti" prop="cuti" align="center" :formatter="formatterKali" />
						<el-table-column label="Dispensasi" prop="dispensasi" align="center" :formatter="formatterKali" />
						<el-table-column label="Tanpa Keterangan" prop="tanpa_keterangan" align="center" :formatter="formatterKali" />
					</el-table-column>
				</el-table>

				<el-pagination
					class="flex-wrap justify-content-center mt-3"
					v-model:current-page="currentPage"
					v-model:page-size="pageSize"
					:page-sizes="[5, 10, 25, 50, 100]"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalData"
					@change="getRekapPresensi" />
			</div>
		</transition>

		<el-dialog ref="dialogDetail" v-model="dialogDetailVisible" :title="dialogTitle" :width="modalWidth" draggable align-center @closed="showDetail">
			<el-table :data="detailRekapPresensi" max-height="400" table-layout="auto" @scroll="handleScrollDetail" class="table-detail-rekap" v-loading="loadingDetail">
				<template #empty>
					<span>{{ loadingDetail ? "Memuat..." : "Data tidak ditemukan" }}</span>
				</template>
				<el-table-column type="index" fixed label="No." />
				<el-table-column label="Hari/Tanggal" fixed prop="tanggal" :formatter="formatterDetail" />
				<el-table-column label="Jadwal Masuk" prop="jam_mulai" :formatter="formatterDetail" />
				<el-table-column label="Jadwal Pulang" prop="jam_selesai" :formatter="formatterDetail" />
				<el-table-column label="Presensi Masuk" prop="waktu_masuk" :formatter="formatterDetail" />
				<el-table-column label="Presensi Pulang" prop="waktu_pulang" :formatter="formatterDetail" />
				<el-table-column label="Tidak Masuk" prop="tidak_hadir" :formatter="formatterDetail" />
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "RekapPresensi",
	data() {
		return {
			rekapPresensi: [],
			totalDetailRekap: 0,
			listUserType: [
				{ label: "Guru", value: "guru" },
				{ label: "Tenaga Kependidikan", value: "karyawan" },
				{ label: "Siswa", value: "siswa" },
			],
			listSemester: [],
			listRombel: [],
			rekapFilter: {
				semester_id: null,
				type: null,
				rombel_id: null,
				tanggal: null,
				search_key: null,
			},
			rowShowedDetail: null,
			dialogTitle: null,
			modalWidth: "50%",
			dialogDetailVisible: false,
			detailRekapPresensi: [],
			debounceFetch: null,
			debounceFetchDetail: null,
			generating: false,
			loading: false,
			loadingDetail: false,
			downloading: false,
			currentPage: 1,
			totalData: 0,
			pageSize: 10,
		};
	},
	props: {
		isPetugasPresensi: Boolean,
	},
	computed: {
		semesterAktif() {
			return this.$store.getters.getSemester;
		},
		rekapFilterClone() {
			return JSON.parse(JSON.stringify(this.rekapFilter));
		},
	},
	watch: {
		semesterAktif: {
			immediate: true,
			handler(val) {
				if (val) {
					this.getListRombel(val.semester_id);
					this.rekapFilter.semester_id = val.semester_id;
				}
			},
		},
		"rekapFilter.type"() {
			clearTimeout(this.debounceFetch);
			this.rekapFilter.rombel_id = null;
			this.rekapFilter.search_key = null;

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getRekapPresensi();
				else this.currentPage = 1;
			}, 0);
		},
		"rekapFilter.semester_id"(newVal, oldVal) {
			clearTimeout(this.debounceFetch);
			this.rekapFilter.rombel_id = null;
			this.rekapFilter.search_key = null;

			this.debounceFetch = setTimeout(() => {
				if (newVal !== oldVal && oldVal !== null) this.getListRombel(newVal);

				if (this.currentPage === 1) this.getRekapPresensi();
				else this.currentPage = 1;
			}, 0);
		},
		"rekapFilter.rombel_id"() {
			clearTimeout(this.debounceFetch);
			this.rekapFilter.search_key = null;

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getRekapPresensi();
				else this.currentPage = 1;
			}, 0);
		},
		"rekapFilter.tanggal"(newVal, oldVal) {
			if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;

			clearTimeout(this.debounceFetch);
			this.rekapFilter.search_key = null;

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getRekapPresensi();
				else this.currentPage = 1;
			}, 0);
		},
		"rekapFilter.search_key"() {
			clearTimeout(this.debounceFetch);

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getRekapPresensi();
				else this.currentPage = 1;
			}, 500);
		},
	},
	mounted() {
		this.handleResize();
		window.addEventListener("resize", this.handleResize);
		this.$ws.main.on("user:updated", this.updatedUser);
		this.$ws.main.on("rekap:generated", this.generatedRekap);
		this.getListSemester();
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.handleResize);
		this.$ws.main.off("user:updated");
		this.$ws.main.off("rekap:generated");
	},
	methods: {
		toWIB(dateStr) {
			const d = new Date(dateStr);
			return new Date(d.getTime() + 7 * 60 * 60 * 1000);
		},
		indexMethod(index) {
			return (this.currentPage - 1) * this.pageSize + index + 1;
		},
		formatterKali(row, col, val) {
			return val ? val + " kali" : "-";
		},
		formatterDetail(row, col, val) {
			if (col.property === "tanggal") {
				const tgl = new Date(val).toLocaleDateString("id-ID", { dateStyle: "full" });
				return tgl;
			}
			if (col.property === "waktu_masuk") {
				if (val) return `${val} (${row.status_masuk})`;
				if (!val && row.status_masuk) return row.status_masuk;
				return "-";
			}
			if (col.property === "waktu_pulang") {
				if (val) return `${val} (${row.status_pulang})`;
				if (!val && row.status_pulang) return row.status_pulang;
				return "-";
			}
			if (!val) return "-";
			return val;
		},
		updatedUser(data) {
			if (this.rekapFilter.type !== data.type) return;

			this.rekapPresensi.every((l) => {
				if (l.user_presensi_id === data.old_user_presensi_id) {
					l.user_presensi_id = data.user_presensi_id;

					return false;
				}
				return true;
			});
		},
		generatedRekap(data) {
			if (this.rekapFilter.type !== data.type) return;

			if (Array.isArray(this.rekapFilter.tanggal)) {
				const tglAwal = this.toWIB(data.tanggal_awal);
				const tglAkhir = this.toWIB(data.tanggal_akhir);

				const awal = new Date(this.rekapFilter.tanggal[0] + "T00:00:00+07:00");
				const akhir = new Date(this.rekapFilter.tanggal[1] + "T23:59:59.999+07:00");

				if (tglAkhir < awal || tglAwal > akhir) return;
			}

			this.getRekapPresensi();
		},
		handleResize() {
			const w = window.innerWidth;
			if (w < 500) this.modalWidth = "95%";
			else if (w < 768) this.modalWidth = "85%";
			else if (w < 992) this.modalWidth = "75%";
			else if (w < 1200) this.modalWidth = "70%";
			else if (w < 1500) this.modalWidth = "65%";
			else if (w < 1920) this.modalWidth = "55%";
			else this.modalWidth = "50%";
		},
		async getListSemester() {
			try {
				const { data } = await this.$defaultApi.get("/user/list-semester");

				this.listSemester = data.data.list_semester;
			} catch (error) {
				console.error(error);
			}
		},
		async getListRombel(semesterId) {
			try {
				const { data } = await this.$defaultApi.get(`/user/list-rombel/${semesterId}`);

				this.listRombel = data.data.list_rombel;
			} catch (error) {
				console.error(error);
			}
		},
		async getRekapPresensi() {
			if (!this.rekapFilter.type) return;

			this.loading = true;
			try {
				const { data } = await this.$defaultApi.get(`/log/rekap/index/${this.rekapFilter.type}`, {
					params: {
						semester_id: this.rekapFilter.type === "siswa" ? this.rekapFilter.semester_id : undefined,
						rombel_id: this.rekapFilter.type === "siswa" ? this.rekapFilter.rombel_id || undefined : undefined,
						search_key: this.rekapFilter.search_key || undefined,
						tanggal_awal: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[0] : undefined,
						tanggal_akhir: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[1] : undefined,
						page: this.currentPage,
						limit: this.pageSize,
					},
				});

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.rekapPresensi = data.data.rekap_presensi;
				this.totalData = data.data.jumlah_data;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.loading = false;
			}
		},
		showDetail(row = null) {
			if (row) {
				if (this.rekapFilter.type === "siswa") {
					this.dialogTitle = `Detail Rekap Presensi · ${row.nama_rombel} · ${row.nis} · ${row.nama}`;
				} else {
					this.dialogTitle = `Detail Rekap Presensi · ${row.nama}`;
				}

				this.dialogDetailVisible = true;
				this.rowShowedDetail = row;
				this.getDetailRekapPresensi();
			} else {
				this.rowShowedDetail = null;
				this.dialogTitle = "Detail Rekap Presensi";
				this.$refs.dialogDetail.resetPosition();
				this.detailRekapPresensi = [];
				this.totalDetailRekap = 0;
			}
		},
		handleScrollDetail(e) {
			const table = document.querySelector(".table-detail-rekap");
			if (!table) return;

			const nearBottom = e.scrollTop + table.clientHeight >= table.scrollHeight - 50;

			if (nearBottom && this.detailRekapPresensi.length < this.totalDetailRekap) {
				clearTimeout(this.debounceFetchDetail);

				this.debounceFetchDetail = setTimeout(() => {
					this.getDetailRekapPresensi();
				}, 500);
			}
		},
		async getDetailRekapPresensi() {
			this.loadingDetail = true;
			try {
				const typeId =
					this.rekapFilter.type === "guru" ? this.rowShowedDetail.guru_id : this.rekapFilter.type === "karyawan" ? this.rowShowedDetail.karyawan_id : this.rowShowedDetail.siswa_id;

				const { data } = await this.$defaultApi.get(`/log/rekap/detail/${this.rekapFilter.type}/${typeId}`, {
					params: {
						tanggal_awal: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[0] : undefined,
						tanggal_akhir: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[1] : undefined,
						page: Math.ceil(this.detailRekapPresensi.length / 25) + 1,
						limit: 25,
					},
				});

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.detailRekapPresensi = this.detailRekapPresensi.concat(data.data.detail_rekap_presensi);
				this.totalDetailRekap = data.data.jumlah_data;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.loadingDetail = false;
			}
		},
		async generateRekapPresensi() {
			this.generating = true;
			try {
				const { data } = await this.$defaultApi.post(`/log/rekap/generate/${this.rekapFilter.type}`, {
					tanggal_awal: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[0] : null,
					tanggal_akhir: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[1] : null,
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.generating = false;
			}
		},
		async downloadRekapPresensi() {
			this.downloading = true;
			try {
				const { data, headers } = await this.$defaultApi.get(`/log/rekap/download/${this.rekapFilter.type}`, {
					params: {
						semester_id: this.rekapFilter.type === "siswa" ? this.rekapFilter.semester_id : undefined,
						rombel_id: this.rekapFilter.type === "siswa" ? this.rekapFilter.rombel_id || undefined : undefined,
						search_key: this.rekapFilter.search_key || undefined,
						tanggal_awal: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[0] : undefined,
						tanggal_akhir: Array.isArray(this.rekapFilter.tanggal) ? this.rekapFilter.tanggal[1] : undefined,
					},
					responseType: "blob",
				});

				const contentDisposition = headers["content-disposition"];
				let fileName = "RekapitulasiPresensi.xlsx";

				if (contentDisposition) {
					const match = contentDisposition.match(/filename="?([^"]+)"?/);
					if (match && match[1]) {
						fileName = decodeURIComponent(match[1]);
					}
				}

				const url = window.URL.createObjectURL(new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));

				const a = document.createElement("a");
				a.href = url;
				a.download = fileName;
				document.body.appendChild(a);

				await new Promise((resolve) => setTimeout(resolve, 500));
				a.click();
				a.remove();
				window.URL.revokeObjectURL(url);
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.downloading = false;
			}
		},
	},
};
</script>

<style scoped></style>
